import React from 'react';
import { formatProfileUpdateLinkExpiry } from '../../utils/profileUpdateLink';

interface ProfileUpdateLinkHelpTextProps {
  expiresAt: string | null;
}

export const ProfileUpdateLinkHelpText: React.FC<ProfileUpdateLinkHelpTextProps> = ({ expiresAt }) => {
  const expiryLabel = formatProfileUpdateLinkExpiry(expiresAt);

  return (
    <p className="text-[11px] text-dark-text-secondary text-right leading-snug">
      <strong className="text-dark-text/90">How this link works:</strong>{' '}
      {expiryLabel ? (
        <>
          Valid until <strong>{expiryLabel}</strong> or until they <strong>save their profile</strong> successfully—whichever
          comes first. They can close and reopen the link anytime before then.
        </>
      ) : (
        <>
          Valid until the expiry date above or until they <strong>save their profile</strong> successfully—whichever comes first.
          They can close and reopen the link anytime before then.
        </>
      )}
      <br />
      <span className="text-dark-text-secondary/95">
        <strong className="text-dark-text/85">Safe to share:</strong> only whoever signs in with the Google account matching{' '}
        <strong>Contact email</strong> below can view or edit this profile. You can email the link, save it in your notes, or send
        it to the candidate or employee—other people cannot use it even if they have the URL.
      </span>
    </p>
  );
};
